import ConnectedRouteHandler from './ConnectedRouteHandler';
import RouteHandler from './RouteHandler';

export { ConnectedRouteHandler, RouteHandler };
export default RouteHandler;
